import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import R from 'ramda'

import {
  Label
} from 'semantic-ui-react'

import {
  notNilOrEmpty,
  isNilOrEmpty
} from '_utils'

const NEVER = new Date('7474-07-04T04:00:00Z')

const TextItem = ({
  text,
  textBg,
  href,
  onClick
}) =>
  notNilOrEmpty(href)
    ? (<Label size='small' as='a' href={href} target='_blank'>{text}</Label>)
    : notNilOrEmpty(onClick)
      ? (<Label size='small' as='a' onClick={onClick}>{text}</Label>)
      : textBg
        ? <Label size='small' color={textBg} onClick={onClick}>{text}</Label>
        : text

TextItem.propTypes = {
  text: PropTypes.string.isRequired,
  textBg: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func
}

const ItemView = ({
  label,
  text,
  textBg,
  href,
  onClick,
  small = false
}) => small
  ? (<div><small><b>{label}</b>: <TextItem text={text} href={href} onClick={onClick} textBg={textBg} /></small></div>)
  : (<div><b>{label}</b>: <TextItem text={text} href={href} onClick={onClick} textBg={textBg} /></div>)

ItemView.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  textBg: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  small: PropTypes.bool
}

const ItemViewWithChildren = ({
  label,
  children,
  small = false
}) => small
  ? (<div><small><b>{label}</b>: <div style={{paddingLeft: '1em', verticalAlign: 'top', display: 'inline'}}>{children}</div></small></div>)
  : (<div><b>{label}</b>: <div style={{paddingLeft: '1em', verticalAlign: 'top', display: 'inline'}}>{children}</div></div>)

ItemViewWithChildren.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  small: PropTypes.bool
}

const Item = R.cond([
  [({disable}) => disable, R.always(null)],
  [({children}) => notNilOrEmpty(children), ItemViewWithChildren],
  [({text}) => isNilOrEmpty(text), R.always(null)],
  [R.T, ItemView]
])

const formatDate = R.cond([
  [isNilOrEmpty, R.always(null)],
  [R.compose(R.equals(NEVER), x => new Date(x)), R.always('never')],
  [R.T, R.tryCatch(x => moment(x).format('YYYY-MM-DD'), R.identity)]
])

const transformDate = {
  text: formatDate
}
const transformText = {
  text: R.ifElse(isNilOrEmpty, R.always(null), String)
}

const LineItem = R.ifElse(
  R.propEq('isDate', true),
  R.compose(Item, R.evolve(transformDate)),
  R.compose(Item, R.evolve(transformText))
)

LineItem.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  textBg: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  small: PropTypes.bool,
  disable: PropTypes.bool,
  isDate: PropTypes.bool
}

export default LineItem



// WEBPACK FOOTER //
// ./webAdmin/views/lineItem.js